import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const images = [
  '/images/image1.avif',
  '/images/image2.avif',
  '/images/image3.avif',
];

const fadeInLeft = {
  hidden: { opacity: 0, x: -60 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      type: 'spring',
    },
  }),
};

const Hero = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  const cards = [
    {
      icon: <img src="/images/learn.jpeg" alt="Gamepad" className="mx-auto mb-4 h-20" />,
      title: "Learn & Succeed Together",
      text: "Build knowledge collaboratively and achieve competitive success."

    },
    {
      icon: <img src="/images/collabrate.jpeg" alt="Trophy" className="mx-auto mb-4 h-20" />,
      title: "Collaborative Study",
      text: "Learn with focused aspirants preparing for competitive exams. Share knowledge, strategies, and stay accountable together."


    },
    {
      icon: <img src="/images/g4.png" alt="Money" className="mx-auto mb-4 h-20" />,
      title: "Study Partners Network",
      text: "Connect with dedicated aspirants and learn in a focused community."

    },
    {
      icon: <img src="/images/g3.png" alt="Shield" className="mx-auto mb-4 h-20" />,
      title: 'Secure & Reliable Platform',
      text: 'safe and stable environment built for serious learners and long-term preparation.',
    },
    {
      icon: <img src="/images/chat.jpg" alt="Shield" className="mx-auto mb-4 h-20" />,
      title: " Chat with Study Partners",
      text: "Connect with peers, clarify doubts, and stay motivated through focused academic conversations."


    },
    {
      icon: <img src="/images/support.jpeg" alt="Mobile" className="mx-auto mb-4 h-20" />,
      title: "Dedicated Support",
      text: "You can Reach out to our support team for  help. whenever you need it during your preparation journey."

    },
  ];

  return (
    <>
      <section
        id="hero"
        className="min-h-screen bg-[#C8F1F9] text-gray-800 px-6 py-10 flex flex-col items-center text-center"
      >
        <h1 className="text-5xl font-extrabold text-[#3498db] drop-shadow mb-4">
          Better Learning. Togethher.
        </h1>
        <p className="text-lg max-w-2xl">
          Supporting students in their academic journey
          through collaboration, clarity and focused preparation.
        </p>

        <section className="py-12">
          <div className="relative w-full max-w-7xl mx-auto overflow-hidden rounded-3xl shadow-2xl">

            {/* Slider */}
            <div
              className="flex transition-transform duration-700 ease-in-out"
              style={{ transform: `translateX(-${current * 100}%)` }}
            >
              {images.map((src, idx) => (
                <div key={idx} className="relative w-full flex-shrink-0">
                  <img
                    src={src}
                    alt={`Slide ${idx + 1}`}
                    className="w-full h-56 sm:h-72 md:h-[420px] object-cover"
                  />

                  {/* Premium Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-transparent" />
                </div>
              ))}
            </div>

            {/* Left Arrow */}
            <button
              onClick={() =>
                setCurrent((current - 1 + images.length) % images.length)
              }
              className=" hidden md:flex absolute top-1/2 left-4 -translate-y-1/2
                 w-11 h-11 rounded-full
                 bg-white/70 backdrop-blur-md
                 flex items-center justify-center
                 text-xl font-bold text-gray-800
                 hover:bg-white transition"
            >
              ‹
            </button>

            {/* Right Arrow */}
            <button
              onClick={() => setCurrent((current + 1) % images.length)}
              className=" hidden md:flex absolute top-1/2 right-4 -translate-y-1/2
                 w-11 h-11 rounded-full
                 bg-white/70 backdrop-blur-md
                 flex items-center justify-center
                 text-xl font-bold text-gray-800
                 hover:bg-white transition"
            >
              ›
            </button>
          </div>
        </section>

        <div className="w-full mt-12 overflow-hidden whitespace-nowrap">
  <marquee
    behavior="scroll"
    direction="left"
    className="text-xl sm:text-2xl md:text-3xl font-semibold text-red-600"
  >
    📖 Learn Better Every Day &nbsp;&nbsp;
    🧠 Build Strong Concepts &nbsp;&nbsp;
    📝 Practice for Improvement &nbsp;&nbsp;
    🎓 Designed for Academic Success &nbsp;&nbsp;
    🔐 Reliable & Secure Learning Platform &nbsp;&nbsp;
     🤝 Better Learning. Together.
  </marquee>
</div>


        <div className="mt-20 max-w-7xl w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 80, scale: 0.9 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              transition={{
                duration: 0.8,
                delay: index * 0.15,
                ease: "easeOut",
              }}
              viewport={{ once: true }}
              className="
        group relative overflow-hidden
        rounded-3xl
        bg-white/70 backdrop-blur-xl
        border border-white/40
        shadow-[0_20px_60px_rgba(0,0,0,0.15)]
        transition-all duration-700
        hover:-translate-y-5 hover:shadow-[0_30px_80px_rgba(0,0,0,0.25)]
      "
            >
              {/* Animated Gradient Glow */}
              <div className="
        absolute inset-0 opacity-0 group-hover:opacity-100
        transition duration-700
        bg-gradient-to-br
        from-[#5DADE2]/30
        via-[#F1948A]/20
        to-[#F5B041]/30
      " />

              {/* Card Content */}
              <div className="relative p-8 text-center">
                {/* Icon Animation */}
                <motion.div
                  animate={{ y: [0, -10, 0], rotate: [0, 3, -3, 0] }}
                  transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                  className="
            w-24 h-24 mx-auto mb-6
            flex items-center justify-center
            rounded-2xl
            bg-gradient-to-br from-[#5DADE2] to-[#3498db]
            shadow-xl
          "
                >
                  {card.icon}
                </motion.div>

                <h3 className="text-3xl font-extrabold tracking-wide text-gray-800 mb-4">
                  {card.title}
                </h3>

                {/* Text */}
                <p className="text-gray-600 text-sm leading-relaxed">
                  {card.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

      </section>
    </>
  );
};

export default Hero;
